import { ViteSSG } from 'vite-ssg';
import App from './App.vue';
import { routes } from './router';
import './style.css';

export const createApp = ViteSSG(App, { routes }, () => {
  // Install plugins, configure app instance, etc.
});
